import React, { useEffect } from "react"
import { Routes, Route } from "react-router-dom"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import AuthMiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import { Toaster } from "react-hot-toast"
import NonAuthMiddleware from "routes/nonAuth"

const App = () => {
  const Layout = VerticalLayout

  return (
    <React.Fragment>
      <Toaster
        containerStyle={{ zIndex: 99999 }}
        toastOptions={{
          duration: 3000,
        }}
        position="top-right"
      />
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthMiddleware>
                <NonAuthLayout>{route.component}</NonAuthLayout>
              </NonAuthMiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthMiddleware>
                <Layout>{route.component}</Layout>
              </AuthMiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

export default App
